const gFormFields = document.querySelectorAll(
  ".gfield input, .gfield textarea"
);

for (i = 0; i < gFormFields.length; i++) {
  gFormFields[i].addEventListener("focus", removePlaceholder);
  gFormFields[i].addEventListener("focusout", addPlaceholder);
}

function removePlaceholder(e) {
  e.target.parentElement.parentElement.classList.add("active");
}

function addPlaceholder(e) {
  if (e.target.value.length === 0) {
    e.target.parentElement.parentElement.classList.remove("active");
  }
}
